// extracted by mini-css-extract-plugin
export default {"mainContainer":"AboutUs_mainContainer__YJ+qA","mainContainerContent":"AboutUs_mainContainerContent__Pj2Dk"};